import React from 'react'
import useListKeyboardInteraction from 'Hooks/useListKeyboardInteraction'
import { Row } from 'react-styled-flexboxgrid-tmp'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import { _Container, _ListCount, _AreaList, _Area, _SubAreaList, _SubArea } from './styles'

const AreaList = (props) => {
  const { list, name } = props

  useListKeyboardInteraction({
    enableKeyboardInteraction: true,
    parentClassName: `.${_AreaList.styledComponentId}`,
    childClassName: `.${_Area.styledComponentId} a`,
  })

  return (
    <_Container>
      <h2>{name} <_ListCount>{list.length}</_ListCount></h2>
      <Row>
        <_AreaList>
          {
            list && list.map(area => {
              const subAreaList = area.sublocalities || area.neighbourhoods
              return (
                <_Area>
                  <Link to={name === 'Buildings' ? `/${area.url}` : `/sitemap/${area.url}`}>
                    {area.display_name}
                  </Link>
                  {
                    subAreaList && subAreaList.length ?
                      <_SubAreaList>
                        {
                          subAreaList.map(subArea => (
                            <_SubArea key={subArea.id}>
                              <Link to={`/sitemap/${subArea.url}`}>
                                {subArea.display_name}
                              </Link>
                            </_SubArea>
                          ))
                        }
                      </_SubAreaList>
                      : null
                  }
                </_Area>
              )
            })
          }
        </_AreaList>
      </Row>
    </_Container>
  )
}

AreaList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape({})),
  name: PropTypes.string,
}

export default AreaList
